import type { ModuleNav } from '@saas/ui';

/** core のメニュー。自分宛て・通知・通知設定は全員、管理は core.* の権限で絞る */
export const coreNav: ModuleNav = {
  module: 'core',
  items: [
    { label: '自分宛て', to: '/', icon: 'inbox', end: true, badge: 'workflow.inbox', description: '承認待ち・未読通知' },
    { label: '通知', to: '/notifications', icon: 'notifications', badge: 'notifications.unread' },
    { label: '通知設定', to: '/settings/notifications', icon: 'settings', description: '種類ごとのプッシュ・メールの受け取り方' },
    // 段 5: 2 要素認証・ログイン中の端末（05 AUTH-05・04 §6.2）
    { label: 'セキュリティ', to: '/settings/security', icon: 'shield', description: '2 要素認証・ログイン中の端末' },
  ],
  admin: [
    { label: 'ユーザー', to: '/admin/users', icon: 'group', permission: 'core.user.manage', description: '招待・ロール・停止' },
    { label: 'APIキー', to: '/admin/api-keys', icon: 'key', permission: 'core.tenant.manage', description: '外部連携の権限・期限・失効' },
    { label: '部署', to: '/admin/departments', icon: 'account_tree', permission: 'core.department.manage' },
    { label: '組織変更予約', to: '/admin/organization-changes', icon: 'schedule', permission: 'core.department.manage', description: '異動・休職を日時指定で反映' },
    { label: 'ロール', to: '/admin/roles', icon: 'shield', permission: 'core.role.manage' },
    { label: 'テナント設定', to: '/admin/tenant', icon: 'business', permission: 'core.tenant.manage', description: '会社名・タイムゾーン・モジュール' },
    // SFA 1A（SFA機能拡張設計書 §15.2.1）。/admin のホーム（AdminHomePage）にもこの行から並ぶ
    { label: '営業日カレンダー', to: '/admin/business-calendar', icon: 'event', permission: 'core.tenant.manage', description: '営業日・営業時間・会社の休日・祝日' },
    { label: 'SAML・SCIM', to: '/admin/identity', icon: 'key', permission: 'core.tenant.manage', description: 'SSO・アカウント同期' },
    { label: '通知の設定', to: '/admin/notifications', icon: 'notifications', permission: 'core.tenant.manage', description: '文面の上書き・本文をロック画面に載せるか' },
    { label: '監査ログ', to: '/admin/audit-logs', icon: 'history', permission: 'core.audit.read' },
    { label: 'イベント配送', to: '/admin/event-deliveries', icon: 'bolt', permission: 'core.outbox.read' },
    { label: '送信記録', to: '/admin/outbound-messages', icon: 'mail', permission: 'core.messaging.read', description: 'メール / SMS の送信記録（招待リンク）' },
    // gap-mail（SFA機能拡張設計書 §3・§15.2.6）
    { label: 'メール接続の管理', to: '/admin/mail-connections', icon: 'inbox', permission: 'core.mail.connection.manage', description: '会社全体の ON/OFF・社員の接続の停止と削除' },
    { label: '契約とプラン', to: '/admin/subscription', icon: 'payments', permission: 'core.billing.read', description: 'プラン・席数・請求の見込み' },
    { label: '使用量', to: '/admin/usage', icon: 'bar_chart', permission: 'core.billing.read' },
    { label: '解約とデータ返還', to: '/admin/exports', icon: 'inventory', permission: 'core.export.execute' },
  ],
};
